const { useState, useEffect } = require('react');

export const useResize = () => {
    const { screenWidth, screenHeight } = useWindowSize();
    return {
        screenWidth,
        screenHeight
    };
};

const useWindowSize = () => {
    let [widthScreen, setWidthScreen] = useState({
        screenWidth: undefined,
        screenHeight: undefined
    });

    useEffect(() => {
        const onResize = () => {
            const screenWidth = window.innerWidth;
            const screenHeight = window.innerHeight;
            setWidthScreen({ screenWidth, screenHeight });
        };
        window.addEventListener('resize', onResize);
        onResize();

        return () => {
            window.removeEventListener('resize', onResize);
        };
    }, []);

    return widthScreen;
};
